import { useQuery } from "@tanstack/react-query";
import { Card } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export const AdminConversions = () => {
  const { data: conversions, isLoading } = useQuery({
    queryKey: ['conversions'],
    queryFn: async () => {
      // Fetch conversion data from various tables
      const [flareApplications, pitchSubmissions, appointments] = await Promise.all([
        supabase.from('flare_applications').select('*', { count: 'exact', head: true }),
        supabase.from('pitch_submissions').select('*', { count: 'exact', head: true }),
        supabase.from('appointments').select('*', { count: 'exact', head: true }),
      ]);

      return {
        flareApplications: flareApplications.count || 0,
        pitchSubmissions: pitchSubmissions.count || 0,
        appointments: appointments.count || 0,
      };
    },
  });

  if (isLoading) {
    return <div>Loading conversion data...</div>;
  }

  const conversionData = [
    { name: 'Flare Applications', value: conversions?.flareApplications || 0 },
    { name: 'Pitch Submissions', value: conversions?.pitchSubmissions || 0 },
    { name: 'Appointments', value: conversions?.appointments || 0 },
  ];

  return (
    <Card className="p-6">
      <h2 className="text-2xl font-bold mb-6">Conversion Tracking</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {conversionData.map((item) => (
          <Card key={item.name} className="p-4">
            <h3 className="text-sm font-medium text-muted-foreground">{item.name}</h3>
            <p className="text-2xl font-bold">{item.value}</p>
          </Card>
        ))}
      </div>

      <Card className="p-4">
        <h3 className="text-lg font-medium mb-4">Conversion Distribution</h3>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={conversionData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </Card>
  );
};